module.exports = __webpack_public_path__ + "img/white.0f49ed05.jpg";